interface RemovedElement {
  el: Element
  parent: Node
}

export const disableProductFruits = (): RemovedElement[] => {
  const removed: RemovedElement[] = []
  document.querySelectorAll('link[href*="productfruits"], [id^="productfruits"], productfruits').forEach(el => {
    if (el.parentNode) {
      removed.push({ el, parent: el.parentNode })
      el.remove()
    }
  })
  return removed
}

export const enableProductFruits = (removed: RemovedElement[]): void => {
  removed.forEach(({ el, parent }) => parent.appendChild(el))
}
